import { useEffect, useState } from "react";

interface CallData {
  callerIDNumber: string;
  isParked?: boolean;
}

interface Extension {
  extension: string;
}

interface LiveActivityData {
  incoming: number;
  outgoing: number;
  parked: number;
  totalCalls: number;
  totalUsers: number;
}

const useLiveActivityData = (
  callsData: CallData[],
  extensions: Extension[]
): LiveActivityData => {
  const [liveActivityData, setLiveActivityData] = useState<LiveActivityData>({
    incoming: 0,
    outgoing: 0,
    parked: 0,
    totalCalls: 0,
    totalUsers: 0,
  });

  useEffect(() => {
    const extSet = new Set(extensions.map((ext) => ext.extension));

    let incoming = 0;
    let outgoing = 0;
    let parked = 0;

    for (const call of callsData) {
      const isOutgoing = extSet.has(call.callerIDNumber);
      isOutgoing ? outgoing++ : incoming++;

      if (call.isParked) parked++;
    }

    setLiveActivityData({
      incoming,
      outgoing,
      parked,
      totalCalls: callsData.length,
      totalUsers: extensions.length,
    });
  }, [callsData, extensions]);

  return liveActivityData;
};

export default useLiveActivityData;
